var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_6444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_radial_752_6444)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_752_6444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8843 6H15.1157C10.0813 6 6 10.0812 6 15.1157V32.8843C6 37.9188 10.0813 42 15.1157 42H32.8843C37.9188 42 42 37.9188 42 32.8843V15.1157C42 10.0812 37.9188 6 32.8843 6Z",
    fill: "url(#paint1_linear_752_6444)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3325 16.5071L27.5421 16.2129L27.7517 15.9229L28.2188 15.271C28.2769 15.1905 28.253 15.0826 28.1664 15.0297C28.081 14.9757 27.9636 14.9979 27.9078 15.0784L27.1946 16.07L26.9805 16.3685C26.3026 16.124 25.5473 15.9875 24.7498 15.9875C23.9535 15.9875 23.197 16.124 22.5192 16.3685L22.3061 16.07L22.0954 15.7769L21.5941 15.0784C21.536 14.9979 21.4198 14.9768 21.3332 15.0297C21.2478 15.0826 21.2238 15.1905 21.2808 15.271L21.7479 15.9229L21.9575 16.2129L22.1683 16.5071C20.5768 17.1961 19.5002 18.5011 19.5002 19.9944H29.9995C29.9995 18.5011 28.9229 17.1961 27.3325 16.5071ZM21.9375 18.0772C21.9375 18.3661 22.1893 18.6 22.5003 18.6C22.8113 18.6 23.0631 18.3661 23.0631 18.0772C23.0631 17.7883 22.8113 17.5554 22.5003 17.5554C22.1893 17.5554 21.9375 17.7883 21.9375 18.0772ZM26.4375 18.0772C26.4375 18.3661 26.6893 18.6 27.0003 18.6C27.3113 18.6 27.5631 18.3661 27.5631 18.0772C27.5631 17.7883 27.3113 17.5554 27.0003 17.5554C26.6893 17.5554 26.4375 17.7883 26.4375 18.0772ZM19.5 20.6906H19.5809H29.9993V28.3551C29.9993 28.9636 29.4684 29.4589 28.8122 29.4589H27.9543C27.984 29.551 28.0011 29.6473 28.0011 29.7489V31.9556C28.0011 32.5324 27.4964 33.0002 26.8743 33.0002C26.2534 33.0002 25.7499 32.5324 25.7499 31.9556V29.7489C25.7499 29.6473 25.7659 29.551 25.7943 29.4589H23.705C23.7334 29.551 23.7505 29.6473 23.7505 29.7489V31.9556C23.7505 32.5324 23.2458 33.0002 22.6249 33.0002C22.0041 33.0002 21.4994 32.5324 21.4994 31.9556V29.7489C21.4994 29.6473 21.5153 29.551 21.5449 29.4589H20.6882C20.032 29.4589 19.5 28.9636 19.5 28.3551V20.6906ZM17.6256 20.6906C17.0035 20.6906 16.5 21.1583 16.5 21.7351V26.2066C16.5 26.7834 17.0035 27.2512 17.6256 27.2512C18.2465 27.2512 18.75 26.7834 18.75 26.2066V21.7351C18.75 21.1583 18.2465 20.6906 17.6256 20.6906ZM30.75 21.7351C30.75 21.1583 31.2535 20.6906 31.8756 20.6906C32.4965 20.6906 33 21.1583 33 21.7351V26.2066C33 26.7834 32.4965 27.2512 31.8756 27.2512C31.2535 27.2512 30.75 26.7834 30.75 26.2066V21.7351Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_752_6444",
    x: -7.33333,
    y: -7.33333,
    width: 62.6667,
    height: 62.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_752_6444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_752_6444",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_752_6444",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24) scale(24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_6444",
    x1: 24.4666,
    y1: -0.270652,
    x2: 23.0959,
    y2: 71.0163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_6444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android-icon.b5ebb76dba7ccddb4349f94b85d396d7.svg";
export { ForwardRef as ReactComponent };